import { useEffect, useState } from "react";

function Logo({ store }) {
  const [broken, setBroken] = useState(!store.logo_url);
  if (broken) {
    const initials = (store.name || "?").split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
    return <div className="w-14 h-14 rounded-xl border border-white/80 bg-cyan-50 text-cyan-800 font-display text-lg font-semibold grid place-items-center shrink-0" aria-hidden="true" data-testid={`store-logo-fallback-${store.slug}`}>{initials}</div>;
  }
  return <img src={store.logo_url} alt="" onError={() => setBroken(true)} className="w-14 h-14 rounded-xl border border-white/80 bg-white object-contain shrink-0" data-logo="1" />;
}
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PageBackground from "@/components/PageBackground";
import { BadgeCheck } from "lucide-react";
import TrustBadge from "@/components/TrustBadge";

export default function Stores() {
  const [stores, setStores] = useState([]);
  useEffect(() => {
    api.get("/stores?limit=200").then((r) => setStores(r.data));
  }, []);
  return (
    <div className="relative">
      <PageBackground variant="mint-cyan" />
      <div className="max-w-7xl mx-auto px-6 py-12 relative z-10">
        <div className="mb-10">
          <div className="pf-chip pf-chip-mint">Partners</div>
          <h1 className="font-display text-5xl md:text-6xl font-medium tracking-[-0.03em] mt-3 text-slate-900">All stores</h1>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stores.map((s) => (
            <Link key={s.id} to={`/store/${s.slug}`} className="pf-card p-6 flex items-center gap-4" data-testid={`store-${s.slug}`}>
              <Logo store={s} />
              <div className="min-w-0">
                <div className="font-display text-lg font-medium text-slate-900 flex items-center gap-1.5">
                  <span className="truncate">{s.name}</span>
                  {s.verified && <BadgeCheck className="w-4 h-4 text-cyan-600 flex-shrink-0" title="Verified" />}
                </div>
                <div className="text-xs text-slate-500 mt-0.5 flex items-center gap-2">
                  <span>{s.coupon_count} offers</span>
                  <TrustBadge trust={s.trust} testid={`store-trust-${s.slug}`} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
